import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 9,
    fontFamily: 'Helvetica',
  },
  header: {
    textAlign: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 15,
    textDecoration: 'underline',
  },
  clientInfo: {
    flexDirection: 'row',
    border: '1pt solid #000',
    borderLeftWidth: 0,
  },
  clientInfoItem: {
    flexDirection: 'row',
    marginRight: 20,
  },
  clientInfoLabel: {
    fontWeight: 'bold',
    marginRight: 5,
    padding: 5,
    borderLeft: '1pt solid #000',
    borderRight: '1pt solid #000',
  },
  clientInfoValue: {
    fontWeight: 'normal',
    width: '20%',
    padding: 5,
  },
  sectionTitle: {
    fontSize: 10,
    textAlign: 'center',
    fontWeight: 'bold',
    paddingBottom: 8,
  },
  listItem: {
    flexDirection: 'row',
    marginBottom: 3,
  },
  listLabel: {
    fontWeight: 'bold',
    width: 100,
  },
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '14.285%', // 14 columns = 100/14
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f5f5f5',
    padding: 5,
  },
  tableCol: {
    width: '14.285%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
  },
  tableCellHeader: {
    fontSize: 7,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 7,
    textAlign: 'center',
  },
  tableCellDetails: {
    fontSize: 7,
    textAlign: 'left',
  },
  tableCellAmount: {
    fontSize: 7,
    textAlign: 'center',
  },
  paidStatus: {
    fontSize: 7,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

const FileOpeningRegisterPdf = ({ data }) => {
  if (!data || !data.length) {
    return null;
  }

  return <Document>
    <Page size="A4" orientation='landscape' style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.title}>File Opening Register</Text>
      </View>

      {/* Fixed Fee Section */}
      <View style={{ border: '1pt solid #000', borderBottomWidth: 0, marginTop: 15, display: 'flex', flexDirection: 'row' }}>
        <Text style={[styles.sectionTitle, { width: '14.285%', padding: 5, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Date</Text>
        <Text style={[styles.listLabel, { width: '14.285%', textAlign: 'center', padding: 5, paddingBottom: 8, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Name</Text>
        <Text style={[styles.listLabel, { width: '14.285%', textAlign: 'center', padding: 5, paddingBottom: 8, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Date Of Birth</Text>
        <Text style={[styles.listLabel, { width: '14.285%', textAlign: 'center', padding: 5, paddingBottom: 8, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>File Reference</Text>
        <Text style={[styles.listLabel, { width: '14.285%', textAlign: 'center', padding: 5, paddingBottom: 8, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Address</Text>
        <Text style={[styles.listLabel, { width: '14.285%', textAlign: 'center', padding: 5, paddingBottom: 8, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Matter</Text>
        <Text style={[styles.listLabel, { width: '14.285%', textAlign: 'center', padding: 5, paddingBottom: 8, boxSizing: 'border-box' }]}>ID Check</Text>
      </View>

      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}></View>
        {data && data.map((client, index) => {
          return <>
            <View View style={styles.tableRow} key={index} >
              {/* Date */}
              <View View style={[styles.tableCol]} >
                <Text style={[styles.tableCell]}> {formatDate(client?.date)}</Text>
              </View>

              {/* Details */}
              <View View style={[styles.tableCol]} >
                <Text style={[styles.tableCellAmount]}>{client.title} {client.forename} {client.surname}</Text>
              </View>

              {/* Office Account */}
              <View style={styles.tableCol} >
                <Text style={[styles.tableCellAmount]}>{client?.dob}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{"AA/SK/BHAM/" + client?.id}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={[styles.tableCellAmount]}>
                  {client.number_street + ",\n"}
                  {client.city + ',\n'}
                  {client.country + ',\n'}
                  {client.postal_code}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={[styles.tableCellAmount]}>
                  {client.matter_type || "Not Defined"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={[styles.tableCellAmount]}>
                  {client.id_carried_out ? client.evidence_relied_upon || "Not defined" : 'No Identification Carried Out'}
                </Text>
              </View>
            </View>
          </>;
        })}
      </View>

    </Page >
  </Document >
};

export default FileOpeningRegisterPdf;